// includes/js-src/shared/paired-limb-forms.ts — which natural-weapon anatomy forms come in PAIRS.
//
// Owner design 2026-09-03 (two-weapon fighting rework): a PAIRED limb (a fist/slam, a claw) with BOTH
// hands bare is two weapons — a monk has two fists — so the paper doll draws it in both hand cells for
// real (no ghost fade) and the engine arms both hands for two-weapon fighting. Any other limb mirrored
// into the off hand (a maw, a pseudopod, a pincer) is still ONE weapon and keeps the ghosted copy.
//
// Shared by the native equipment compiler and the three paper dolls.

/** NaturalWeaponForm UUIDs (includes/additions.php) that pair on an upright body. */
export const PAIRED_LIMB_FORM_IDS: ReadonlySet<string> = new Set([
    'DDB21DE1-F41C-4456-B99C-D1B9D8742B84', // slam — the Living Weapon fist ladder's form
    'F7944C69-7A83-4BF1-9B39-C4EE05951309', // claw
]);

/** The engine's d1 "Slam (d1)" fist marker: a placeholder, never a two-weapon partner. */
export const ENGINE_FIST_MARKER_ID = '2F2C15E1-4F12-CE3A-74F7-6E20A8A12860';

/** True when a natural weapon with this form / id counts as TWO weapons when it is the only hand limb. */
export function isPairedLimb(formId: string | null | undefined, itemId: string | null | undefined): boolean {
    const id = String(itemId ?? '').trim().toUpperCase();
    if (id === ENGINE_FIST_MARKER_ID) return false;
    const form = String(formId ?? '').trim().toUpperCase();
    return form !== '' && PAIRED_LIMB_FORM_IDS.has(form);
}

/** Does this BODY pair its hand limbs? False only for a creature flagged `quadruped` — its front limbs
 *  walk on the ground, so a lone claw is the whole claw attack, not half a pair. Default TRUE keeps
 *  every unflagged creature exactly as it shipped, and a player character is upright by definition.
 *  Pass the already-read layer value plus the body's item_type (the call sites own their readers).
 *  Both the compiler and presentation call this reader, including the player-character override. */
export function bodyPairsLimbs(quadrupedFlag: unknown, itemType?: unknown): boolean {
    if (String(itemType ?? '') === 'player_character') return true;
    const flag = Array.isArray(quadrupedFlag) ? quadrupedFlag[0] : quadrupedFlag;
    return Number(flag ?? 0) !== 1;
}
